import React from 'react';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { IconAddSvg } from 'apps/sigma2-ui/src/components/svg/IconAdd';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const DashboardFOBButton = ({
  setShowNewChartMenu,
}: {
  setShowNewChartMenu: Setter<boolean>;
}) => {
  return (
    <div data-testid="dashboard-fob-button" className="self-end pr-4">
      <PrimaryButtonLightBg
        onClick={() => setShowNewChartMenu(true)}
        disabled={false}
        icon={() => <IconAddSvg wantsColor="white" />}
        circle
        className="z-20"
      />
    </div>
  );
};
